import styled from "styled-components";

export const SectionForm = styled.section`
    padding-bottom: 150px;
`;

export const FormContainer = styled.div`
    max-width: 1230px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 25px;
    padding-right: 25px;
`;

export const FormTitle = styled.h2`
    font-weight: 700;
    font-size: 79px;
    margin-bottom: 74px;
    line-height: 1;
    position: relative;
    z-index: 1;
    @media (max-width: 1199px) {
        font-size: 60px;
        margin-bottom: 64px;
    }
    @media (max-width: 599px) {
        font-size: 50px;
        margin-bottom: 34px;
    }
`;

export const FormBackplate = styled.div`
    background: #fff;
    border-radius: 35px;
    padding: 89px 80px 96px;
    max-width: 800px;
    margin-right: auto;
    margin-left: auto;
    @media (max-width: 599px) {
        padding: 30px;
    }
`;
